import type { PiecewiseCondition } from '@/types/api/constraints'

export interface AccountValueBound {
  upper: number | undefined
  lower: number | undefined
}

// Single reader for the account-market-value tier convention (non-last tiers
// carry less_than_or_equal_to, the catch-all carries greater_than), shared by
// the tier builder/parser and the piecewise text renderer so the wire
// convention can't drift between them.
export function readAccountValueBound(
  condition: PiecewiseCondition | undefined,
): AccountValueBound {
  const accountValue = condition?.account_market_value
  const upper =
    asNumber(accountValue?.less_than_or_equal_to) ??
    asNumber(accountValue?.less_than)
  const lower =
    asNumber(accountValue?.greater_than) ??
    asNumber(accountValue?.greater_than_or_equal_to)
  return { upper, lower }
}

const asNumber = (value: string | number | undefined): number | undefined =>
  typeof value === 'number' ? value : undefined
